// import { useLanguage } from '../../../hooks';
import { ReactComponent as Audio } from '../../../assets/img/icons/audio.svg';
import { ReactComponent as Subs } from '../../../assets/img/icons/subs.svg';
import { ContentTVUnit, ContentType, ContentUnit } from '../../../services/content_v1';

interface ContentItemInfoProps {
    unit: ContentUnit | ContentTVUnit
    dotted?: boolean
}

export function ContentItemInfo({ unit, dotted }: ContentItemInfoProps) {
    // const lang = useLanguage();
    const quality = unit.ctype === ContentType.UNIT ? (unit as ContentUnit).qualities : (unit as ContentTVUnit).tvqualities;

    return (
        dotted ?
            <ul className="content-item__info-item">
                {!!unit.countries?.length &&
                    unit.countries?.map(c => <li key={c.id}>{c.name}</li>)
                }
                
                {!!quality?.length &&
                    quality?.map(q => <li key={q.id}><span className="label-quality">{q.name}</span></li>)
                }
                {!!unit.languages.length &&
                    <li>
                        <span className="label-audio">
                            <Subs />{unit.languages.map(l => l.name).join(', ')}
                        </span>
                    </li>
                }
                {!!unit.subtitles.length &&
                    <li>
                        <span className="label-audio">
                            <Audio />{unit.subtitles.map(l => l.name).join(', ')}
                        </span>
                    </li>
                }
            </ul>
            :
            <div className="content-item__info">
                {!!unit.countries?.length &&
                    <ul className="content-item__info-item">
                        {unit.countries?.map(c => <li key={c.id}>{c.name}</li>)}
                    </ul>
                }
                {!!quality?.length &&
                    <div className="content-item__info-item">
                        {quality?.map(q => <span key={q.id} className="label-quality">{q.name}</span>)}
                    </div>
                }
                <ul className="content-item__info-item">
                    {!!unit.languages.length &&
                        <li>
                            <span className="label-audio">
                                <Subs />{unit.languages.map(l => l.name).join(', ')}
                            </span>
                        </li>
                    }
                    {!!unit.subtitles.length &&
                        <li>
                            <span className="label-audio">
                                <Audio />{unit.subtitles.map(l => l.name).join(', ')}
                            </span>
                        </li>
                    }
                </ul>
            </div>
    );
}